import React, { forwardRef } from "react"
import MDBoxRoot from "./MDBoxRoot"
import { MDBoxProps } from "./types"

const MDBox = forwardRef<HTMLDivElement, MDBoxProps>(
  (
    {
      variant = "contained",
      bgColor,
      color,
      opacity = 1,
      borderRadius = "none",
      shadow = "none",
      coloredShadow = "none",
      ...rest
    },
    ref
  ) => (
    <MDBoxRoot
      ref={ref}
      ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow }}
      {...rest}
    />
  )
)

MDBox.displayName = "MDBox"

export default MDBox
